import React from "react";
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    LabelList,
} from "recharts";
import { Box, Typography } from "@mui/material";

export default function ResumoOcupacaoChart({ resumo }) {
    const CAP_TOTAL = 44 + 16;

    const data = [
        {
            periodo: "Almoço",
            ocupados:
                CAP_TOTAL - resumo.almoco.lugaresDisponiveis,
            total: CAP_TOTAL,
        },
        {
            periodo: "Jantar",
            ocupados:
                CAP_TOTAL - resumo.jantar.lugaresDisponiveis,
            total: CAP_TOTAL,
        },
    ];

    return (
        <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <ResponsiveContainer width="100%" height={220}>
                <BarChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="periodo" />
                    <YAxis allowDecimals={false} />
                    <Tooltip />
                    <Bar
                        dataKey="ocupados"
                        fill="#071739"
                        radius={[6, 6, 0, 0]}
                    >
                        <LabelList
                            dataKey="ocupados"
                            position="top"
                            fontWeight={800}
                        />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </Box>
    );
}